// extracted by mini-css-extract-plugin
export default {"header":"ClientReplyFormModal_header__2TvS8","headerTitle":"ClientReplyFormModal_headerTitle__X3XNi"};